import { isSafeHttpUrl } from './shortcutUrl';

export async function openShortcutInBrowser(url) {
  if (!isSafeHttpUrl(url)) {
    throw new Error('Only http and https links can be opened');
  }

  const electronApi = typeof window !== 'undefined' ? window.electronAPI : null;
  if (electronApi) {
    if (typeof electronApi.openExternalUrl !== 'function') {
      throw new Error(
        'This Signal Bridge Console build cannot open links in the system browser. Install a Console update that includes Open in browser.'
      );
    }
    const result = await electronApi.openExternalUrl(url);
    if (result && result.success === false) {
      throw new Error(result.error || 'Could not open in browser');
    }
    return { mode: 'electron' };
  }

  // Do not pass noopener in the feature string: Chrome then returns null even
  // when the tab opened, which we were treating as a popup block.
  const opened = window.open(url, '_blank');
  if (!opened) {
    throw new Error('The browser blocked opening this link');
  }
  opened.opener = null;
  return { mode: 'web' };
}
